import React, { useEffect, useState } from 'react';
import { Typography, Link, Button } from '@one-thd/sui-atomic-components';
import { AddTo } from '@thd-olt-component-react/add-to';
import { useConfigService } from '@thd-nucleus/experience-context';
import PropTypes from 'prop-types';
import { extend } from '@thd-nucleus/data-sources';

export const AddToVariations = ({ storeId, pod }) => {
  const ADDTOPROJECTONLY = 'ADDTOPROJECTONLY';
  const THREELINKS = 'THREELINKS';
  const ADDTOBUTTONONLY = 'ADDTOBUTTONONLY';
  const [addToVariation, setAddToVariation] = useState(ADDTOPROJECTONLY);

  const addToButtonOnlyFS = useConfigService('fs:b2b_add_to_button_only');
  const addToThreeLinksFS = useConfigService('fs:b2b_add_to_three_links');

  useEffect(() => {
    if (addToButtonOnlyFS) {
      setAddToVariation(ADDTOBUTTONONLY);
    }
    if (addToThreeLinksFS) {
      setAddToVariation(THREELINKS);
    }
  }, [addToButtonOnlyFS, addToThreeLinksFS]);

  return (
    <>
      {addToVariation === THREELINKS && (
        <div className={'sui-w-full sui-inline-flex sui-items-center ' +
          'lg:sui-justify-start sm:sui-justify-between sui-justify-start sm:sui-gap-3 sui-gap-6 sui-flex-wrap'}
        >
          <Typography weight="bold">Add to:</Typography>
          <AddTo
            products={[{
              itemId: pod.itemId,
              quantity: pod.quantity
            }]}
            storeId={storeId}
            addToType="List"
            addToTypeFromProp="List"
            CustomAddToActionElement={({ onClick, disabled }) => {
              return (
                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                <Link
                  disabled={disabled}
                  component="button"
                  color={!disabled ? 'primary' : 'inactive'}
                  data-testid="add-to-list"
                  data-component="AddToList"
                  onClick={onClick}
                >
                  List
                </Link>
              );
            }}
          />
          <AddTo
            products={[{
              itemId: pod.itemId,
              quantity: pod.quantity
            }]}
            storeId={storeId}
            addToType="Quote"
            addToTypeFromProp="Quote"
            simpleAddToQuote
            CustomAddToActionElement={({ onClick, disabled }) => {
              return (
                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                <Link
                  disabled={disabled}
                  component="button"
                  color={!disabled ? 'primary' : 'inactive'}
                  data-testid="add-to-quote"
                  data-component="AddToQuote"
                  onClick={onClick}
                >
                  Quote
                </Link>
              );
            }}
          />
          <AddTo
            products={[{
              itemId: pod.itemId,
              quantity: pod.quantity
            }]}
            storeId={storeId}
            addToType="Project"
            addToTypeFromProp="Project"
            CustomAddToActionElement={({ onClick, disabled }) => {
              return (
                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                <Link
                  disabled={disabled}
                  component="button"
                  color={!disabled ? 'primary' : 'inactive'}
                  data-testid="add-to-project"
                  data-component="AddToProject"
                  onClick={onClick}
                >
                  Project
                </Link>
              );
            }}
          />
        </div>
      )}
      {addToVariation === ADDTOBUTTONONLY && (
        <AddTo
          products={[{
            itemId: pod.itemId,
            quantity: pod.quantity,
            itemType: 'catalog'
          }]}
          storeId={storeId}
          showSelectionScreen
          simpleAddToQuote
          CustomAddToActionElement={({ onClick }) => {
            return (
              <Button
                variant="secondary"
                data-testid="add-to"
                data-component="AddTo"
                onClick={onClick}
                fullWidth
              >
                Add To...
              </Button>
            );
          }}
        />
      )}
      {addToVariation === ADDTOPROJECTONLY && (
        <AddTo
          products={[{
            itemId: pod.itemId,
            quantity: pod.quantity
          }]}
          storeId={storeId}
          addToType="Project"
          addToFallbackType="List"
        />
      )}
    </>
  );
};

AddToVariations.propTypes = {
  storeId: PropTypes.string.isRequired,
  pod: PropTypes.shape({
    itemId: PropTypes.string.isRequired,
    quantity: PropTypes.number
  })
};

AddToVariations.defaultProps = {
  pod: {
    quantity: 1
  }
};

AddToVariations.dataModel = extend(AddTo);
